import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'

export default {
  SET_PAGE(state, payload) {
    state.page = payload
  },
  SET_ITEMS(state, payload) {
    if (state.page === 1) {
      state.items = payload.mass_payments_history || []
    } else {
      state.items = [...state.items, ...(payload.mass_payments_history || [])]
    }
    state.total = payload.total
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_SORTING(state, payload) {
    state.sort = payload
  },
  SET_SEARCH(state, payload) {
    state.search = payload
  },
  RESET_SEARCH(state) {
    state.search = null
  },
  RESET_PAGE(state) {
    state.items = []
    state.page = 1
    state.total = 10
  },
  RESET_STORE(state, { resetSort = true } = {}) {
    state.loading = false

    state.items = []
    state.page = 1
    state.total = 10

    state.detailSearch = null
    state.detailItems = []
    state.detailPage = 1
    state.detailTotal = 0

    if (resetSort) {
      state.sort = {
        sort_by: 'last_successful_transaction_time',
        sort_direction: SORT_DIRECTION.DESC,
      }
    }
  },

  SET_DETAIL_LOADING(state, status) {
    state.detailLoading = status
  },
  SET_DETAIL_FORM_DATA(state, payload) {
    state.detailFormData = payload
  },
  SET_DETAIL_ITEMS(state, { items, total, reset = false }) {
    if (reset) {
      state.detailItems = items || []
    } else {
      state.detailItems = [...state.detailItems, ...(items || [])]
    }
    if (total !== undefined) {
      state.detailTotal = total
    }
  },
  SET_FILTER(state, { key, payload }) {
    state.filters[key] = payload
  },
  CLEAR_DETAIL_ITEMS(state) {
    state.detailItems = []
    state.detailPage = 1
    state.detailTotal = 0
  },
  SET_DETAIL_PAGE(state, page) {
    state.detailPage = page
  },
  RESET_DETAIL_PAGE(state) {
    state.detailPage = 1
  },
  SET_DETAIL_SEARCH(state, payload) {
    state.detailSearch = payload
  },
  RESET_DETAIL_SEARCH(state) {
    state.detailSearch = null
  },
}
